import { getPath } from '@/router/common'

const baseUrl = {
  title: '高拍仪拍照',
  path: 'GpyTakePhotos'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'PhotosIndex',
    component: () => import(/* webpackChunkName: "ImgView" */ '@/views/gpyTakePhotos/index.vue'),
    meta: {
      title: '高拍仪拍照'
    }
  },
  {
    path: getPath('JieYuDoccamera', baseUrl),
    name: 'JieYuDoccamera',
    component: () => import(/* webpackChunkName: "JieYuDoccamera" */ '@/views/gpyTakePhotos/jieYuDoccamera/index.vue'),
    meta: {
      title: '捷宇高拍仪拍照'
    }
  },
  {
    path: getPath('RZYan', baseUrl),
    name: 'GpyTakePhotos_RZYan',
    component: () => import(/* webpackChunkName: "GpyTakePhotos_RZYan" */ '@/views/gpyTakePhotos/rZYan/index.vue'),
    meta: {
      title: '扫码入库'
    }
  },
  {
    path: getPath('DianYiPai', baseUrl),
    name: 'GpyTakePhotos_DianYiPai',
    component: () => import(/* webpackChunkName: "GpyTakePhotos_DianYiPai" */ '@/views/gpyTakePhotos/dianYiPai/index.vue'),
    meta: {
      title: '点易拍高拍仪拍照'
    }
  }
]
